import KontakContent from "../modules/kontak/component/KontakContent";
import React from "react";

const Kontak: React.FC = () => {
  return (
    <div>
      <KontakContent />
    </div>
  );
};

export default Kontak;
